module.exports = __webpack_public_path__ + "static/color element-53-af201231898f7c19a4f2ca72c421d3c8.png";